import React from 'react';
import PropTypes from 'prop-types';
import VisibilitySensor from 'react-visibility-sensor';

import Skeleton from '../skeleton';

class MediaItem extends React.Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            isLoaded: false,
        };
    }

    loadImage = isVisible => {
        if (isVisible && !this.state.wasVisible) {
            this.setState({ wasVisible: true });
        }
        if (this.state.loading || !this.state.wasVisible || !this.props.src) return;
        const { src } = this.props;
        const fakeImg = document.createElement('img');
        fakeImg.src = src;
        this.setState({ loading: true, isVisible });
        fakeImg.onload = () => {
            this.setState({ isLoaded: true });
        };
        fakeImg.onerror = () => {
            this.setState({ isLoaded: true });
        };
    };
    componentDidUpdate(props, prevProps) {
        if (props.src !== prevProps) {
            this.loadImage();
        }
    }
    render() {
        return this.state.isLoaded ? (
            <img
                className={this.props.extendClass}
                alt={this.props.name || this.props.src}
                src={this.props.src}
            />
        ) : (
            <VisibilitySensor partialVisibility={true} onChange={this.loadImage}>
                <Skeleton className={this.props.extendClass} />
            </VisibilitySensor>
        );
    }
}

MediaItem.propTypes = {
    src: PropTypes.string,
    extendClass: PropTypes.string,
    name: PropTypes.string,
};

export default MediaItem;
